import { type TabbedSelectOption } from '@resources/js/components/TabbedSelect/TabbedSelect';
import React, { type ReactNode, type JSX } from 'react';
import { type LinkProps } from 'next/link';
import LinkWrapper from '../LinkWrapper/LinkWrapper';

type MobileCategorySelectLinkOptionWrapperProps = {
  option: TabbedSelectOption;
  children: ReactNode;
} & Partial<LinkProps>;

export function MobileCategorySelectLinkOptionWrapper({
  option,
  children,
  ...rest
}: MobileCategorySelectLinkOptionWrapperProps): JSX.Element {
  if (option.url) {
    return (
      <LinkWrapper {...rest} href={option.url.split('#')[0]} scroll={false}>
        {children}
      </LinkWrapper>
    );
  }

  return <>{children}</>;
}
